<template>
<div>
  <div class="swaychat-icons">
    <ul v-if="!isSwayChatPopout">
      <li class="swaychat-minimize-wrapper" @click="toggleMinimize"><span class="swaychat-minimize"></span></li>
      <li v-if="allowPopOut || isMinimize" class="swaychat-popout-wrapper" @click.stop="doPopOutClose"><span class="swaychat-popout"><span></span></span>
      </li>
    </ul>
  </div>
  <div id="swaychat-minimize" class="swaychat-chathead swaychat-primary-bg" :style="{ 'background': getPrimaryBg }" @click="toggleMinimize">

    <!-- agent chat head -->
    <div v-if="getViewState == 3 && getAgent" class="swaychat-chathead-wrapper swaychat-zoomIn">

      <div class="swaychat-chathead-img">
        <div class="swaychat-badge swaychat-bounceIn" v-if="getUnread">{{ getUnread }}</div>
        <div class="swaychat-chathead-ini"><span :style="{ 'background-color' : getAgent.agentBg ? getAgent.agentBg : '' }">{{ getAgent.initial }}</span></div>
        <div class="swaychat-chathead-src" v-if="getAgent.avatar">
          <img :src="makeAliasHost(getAgent.avatar)" style="display:none" onload="this.style.display = ''" class="swaychat-bounceIn">
        </div>
      </div>

      <div class="swaychat-agent-details swaychat-zoomIn">
        <h6>
          <div class="swaychat-agent-name">{{ getAgent.nickname }}</div>
          <span class="swaychat-agent-title" v-if="!isOperatorTyping">{{ getAgent.title }}</span>
          <span class="swaychat-agent-title" v-else>{{ getLang.typing }}</span>
        </h6>
      </div>

    </div>

    <!-- prechat head -->
    <div v-else class="swaychat-chathead-wrapper" id="swaychat-prechat-header">

      <div class="swaychat-chathead-img">
        <div class="swaychat-badge swaychat-bounceIn" v-if="getUnread">{{ getUnread }}</div>
        <div class="swaychat-chathead-src">
          <img :src="makeAliasHost(getDefaultImg)" style="display:none" :style="{ 'background-color' : getAvatarBg }" onload="this.style.display = ''" class="swaychat-bounceIn">
        </div>
      </div>

      <div v-show="isOnline" class="swaychat-agent-details swaychat-zoomIn">
        <h6>
          <div class="swaychat-agent-name">{{ getPrechatTitle }}</div>
          <span class="swaychat-agent-title">{{ getPrechatSub }}</span>
        </h6>
      </div>

      <div v-show="!isOnline" class="swaychat-agent-details swaychat-zoomIn">
        <h6>
          <div class="swaychat-agent-name">{{ getPrechatTitle }}</div>
          <span class="swaychat-agent-title">{{ getPrechatSub }}</span>
        </h6>
      </div>

    </div>

  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import {
  API
} from '../utils/api'


export default {
  computed: {
    ...mapGetters([
      'allowPopOut',
      'isMinimize',
      'getPrimaryBg',
      'getAvatarBg',
      'getDefaultImg',
      'getPrechatTitle',
      'getPrechatSub',
      'isOnline',
      'getViewState',
      'isSwayChatPopout',
      'getAgent',
      'getUnread',
      'getLang',
      'isOperatorTyping'
    ])
  },
  methods: {
    doPopOutClose() {
      if (!this.isMinimize) {
        API.$emit('popOutOpen')
      } else
        this.$store.commit('setHidden', true)
    },
    toggleMinimize() {
      if (!this.isSwayChatPopout)
        this.$store.dispatch('toggleMinimize', true)
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }
}
</script>
